import { Component } from 'preact';
import style from './styles/RegistrationArea.scss';
import { CLIENT } from '../../../parameters';
import RegistrationAreaContent from './RegistrationAreaContent';
import { DesktopXL } from '../../../helpers/MediaQueries';

/**
 * @property {?Raffle}         props.raffle       Raffle
 * @property {?number}         state.scrollY      How much has the user scrolled in pixels
 */
export default class RegistrationArea extends Component {

	state = {
		scrollY: 0
	};

	handleScroll = () => {
		// Used pageYOffset instead of scrollY for compatibility with IE11
		const scrollY = window.pageYOffset;
		if (scrollY < 600) {
			this.setState({ scrollY });
		}
	};

	componentDidMount() {
		if (CLIENT) {
			window.addEventListener('scroll', this.handleScroll);
		}
	}

	componentWillUnmount() {
		if (CLIENT) {
			document.removeEventListener('scroll', this.handleClickOutside);
		}
	}

	/**
	 * The RegistrationAreaContent does not re-render needlessly when we scroll - it implements shouldComponentUpdate method.
	 */
	render({ className, raffle, suggestedShopId }, { scrollY }) {
		const showLinkToFootshop = raffle.showLinkToFootshop();
		return (
			<div className={`${className + (showLinkToFootshop ? ' show-footshop-link' : '')}`}>
				<div className={style.registration} style={`top: ${Math.min(-265 + scrollY, 0)}px;`}>
					<RegistrationAreaContent
						raffle={raffle}
						suggestedShopId={suggestedShopId}
					/>
				</div>
				<DesktopXL>
					<div className={style['registration-placeholder']} />
				</DesktopXL>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/blocks/raffleDetail/RegistrationArea.js